var render = function render(){var _vm=this,_c=_vm._self._c;return _c(_vm.fetchedIcons,_vm._b({tag:"component",class:_vm.iconClass},'component',_vm.$attrs,false))
}
var staticRenderFns = []

export { render, staticRenderFns }